var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}

site.frontpage = {
	init: function() {
		if ($('body').is('.is')) {
			site.owl.init('#owl-hero', {
				nav:true,
				navText:['<i class="fa fa-angle-left" />','<i class="fa fa-angle-right" />'],
				items:1,
				loop:1,
				autoplay:true,
				smartSpeed:500,
				animateIn:'fadeIn',
				animateOut:'fadeOut',
				dots:false
			});
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.formbuilder = {
	init: function() {
		var $body = $('body');
		var $borgunForm = $('form.borgun');
		if (!$borgunForm || $body.is('.admin')) return;

		var $isEnglish = $borgunForm.is('.english');
		var $totalText = $isEnglish ? 'Total' : 'Samtals';
		var $quantityText = $isEnglish ? 'Quantity' : 'Fjöldi';
		var $currency = $isEnglish ? 'ISK' : 'kr.';

		var $totalElm = '<div class="elm elm_total"><span class="total--label">' + $totalText + ': ' + '</span><span class="total--number"></span></div>';

		$('.elm_payment').last().after($totalElm);

		$borgunForm.find('.quantity').each(function() {
			$(this).text($quantityText + ':');
		});

		$('.elm_payment input[type=number]').on('change keyup', function() {
			var $min = parseInt($(this).attr('min'));
			var $max = parseInt($(this).attr('max'));
			var $newValue = parseInt($(this).val());
			if ($newValue < $min || !$newValue) {
				$(this).val($min);
			} else if ($newValue > $max) {
				$(this).val($max);
			}
			var $total = parseInt(0);
			$('.elm_payment').each(function() {
				var $count = $(this).find('input[type=number]').val();
				var $price = $(this).find('.data').text().replace(/\D/g,'');
				$total += $count * $price;
			});
			$total = site.formbuilder.formatMoney($total, 0, ',', '.');
			$('.total--number').text($total + ' ' + $currency);
		});
	},

	formatMoney: function(n, c, d, t){
		var c = isNaN(c = Math.abs(c)) ? 2 : c,
			d = d === undefined ? "." : d,
			t = t === undefined ? "," : t,
			s = n < 0 ? "-" : "",
			i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			j = (j = i.length) > 3 ? j % 3 : 0;
		return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	var $body = $('body');
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}
	if ($body.is('.forsida')) {
		site.frontpage.init();
	}
	if ($body.is('.formbuilder')) {
		site.formbuilder.init();
	}
	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
